"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTM_PROVIDER_BY_COUNTRY = exports.TTM_REQUESTER_ACCOUNTS = exports.TTM_PROVIDER_ACCOUNTS = void 0;
const countries_1 = require("../world/countries");
exports.TTM_PROVIDER_ACCOUNTS = [
    "4509",
    "2841",
    "4444",
    "3517", // TTM Demo account
    "5164",
    "2392", // TTM Demo account
];
exports.TTM_REQUESTER_ACCOUNTS = ["4510", "3075", "4355"];
exports.TTM_PROVIDER_BY_COUNTRY = {
    [countries_1.COUNTRY_BY_CODE.IE.code]: 2841,
    [countries_1.COUNTRY_BY_CODE.GB.code]: 4509,
};
